import { ModuleLayout } from "layouts";
import AllTickets from "./AllTickets";

function Tickets() {
  return (
    <ModuleLayout title="Tickets">
      <AllTickets />
    </ModuleLayout>
  );
}
export default Tickets;
